var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 256 256",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.752 201.78L123.152 183.088L94.4245 144.337L88.042 152.996L111.752 201.78",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.973 232.784L188.346 232.784L188.346 250.563L62.973 250.563L62.973 232.784",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.987 183.088L140.019 201.78L165.097 152.996L157.802 144.337L129.987 183.088",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.756 209.075C142.3 209.987 141.388 210.443 140.475 210.443L140.475 210.443C139.567 210.443 138.65 209.987 138.199 209.075L126.798 188.558L114.489 209.075C114.033 209.987 113.12 210.443 112.208 210.443L112.208 210.443C111.3 210.443 110.388 209.987 109.931 209.075L83.9407 155.734L72.5444 160.291L72.5444 160.291L29.6873 175.337L29.6873 250.563L58.4108 250.563L58.4108 230.047L58.4108 229.591L58.4108 229.139L58.4108 218.194C58.4108 216.826 59.7794 215.457 61.1435 215.457C62.5122 215.457 63.8808 216.826 63.8808 218.194L63.8808 226.858L189.263 226.858L189.263 218.194C189.263 216.826 190.627 215.457 191.996 215.457C193.364 215.457 194.728 216.826 194.728 218.194L194.728 250.563L222.996 250.563L222.996 175.794L170.111 156.19L142.756 209.075",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.784 57.2545C121.784 58.6232 122.24 59.5356 123.152 60.4435C124.065 61.356 125.434 61.8167 127.254 62.2684L127.254 52.2407C123.604 52.6969 121.784 54.5173 121.784 57.2545",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.286 82.7845C137.286 81.4158 136.83 80.5079 135.461 79.5955C134.549 78.6831 132.724 78.2269 130.904 77.3144L130.904 86.8904C135.461 86.8904 137.286 85.5218 137.286 82.7845",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7057 73.2085L74.8255 73.2085C75.2772 85.978 80.7518 97.3743 88.5029 106.494L82.1204 112.877C81.208 113.789 81.208 115.614 82.1204 116.978C82.5721 117.439 83.489 117.89 83.9407 117.89C84.4015 117.89 85.3094 117.439 85.7656 116.978L92.1481 110.596C101.724 119.259 114.489 124.273 128.166 124.273C141.844 124.273 154.613 118.803 164.185 110.596L170.567 116.978C171.019 117.439 171.936 117.89 172.388 117.89C172.848 117.89 173.761 117.439 174.212 116.978C175.129 116.07 175.129 114.245 174.212 112.877L167.83 106.494C176.037 97.3743 181.051 85.978 181.512 73.2085L190.627 73.2085C191.996 73.2085 193.364 71.8444 193.364 70.4758C193.364 69.1071 191.996 67.743 190.627 67.743L181.512 67.743C181.051 54.9735 175.581 43.5772 167.83 34.4574L174.212 28.075C175.129 27.1625 175.129 25.3377 174.212 23.9735C173.3 23.0611 171.48 23.0611 170.111 23.9735L164.636 30.356C155.521 22.1487 144.12 17.1348 131.355 16.6786L131.355 7.55886C131.355 6.19474 129.987 4.82158 128.623 4.82158C127.254 4.82158 125.885 6.19474 125.885 7.55886L125.885 16.6786C113.12 17.1348 101.724 22.6049 92.6043 30.356L86.2218 23.9735C85.3094 23.0611 83.489 23.0611 82.1204 23.9735C81.208 24.886 81.208 26.7108 82.1204 28.075L88.5029 34.4574C80.291 43.5772 75.2772 54.9735 74.8255 67.743L65.7057 67.743C64.3371 67.743 62.973 69.1071 62.973 70.4758C62.973 72.3006 64.3371 73.2085 65.7057 73.2085",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/default-user.d57e56d2a45782ed555f0af718d07bfa.svg";
export { ForwardRef as ReactComponent };